import { ROUTES } from '@/constants';

interface LobbyBackRouteParams {
	state: {
		isFromHomePage?: boolean;
		isFromEventsPage?: boolean;
		isFromProfilePage?: boolean;
	} | null;
	isRegisteredUser: boolean;
	isFromSharedLink: boolean;
}

/** The page a lobby's Back button returns to, or null to go back in history. */
export const getLobbyBackRoute = ({
	state,
	isRegisteredUser,
	isFromSharedLink,
}: LobbyBackRouteParams): string | null => {
	if (state?.isFromHomePage) return ROUTES.HOME;
	if (state?.isFromEventsPage) return ROUTES.EVENTS;
	if (state?.isFromProfilePage) return ROUTES.PROFILE;
	if (isRegisteredUser && isFromSharedLink) return ROUTES.EVENTS;
	return null;
};
